import { NavLink } from 'react-router-dom'
import { useLanguage } from '../../i18n/index.jsx'
import { useSettingsStore } from '../../store/settingsStore.js'
import { usePolicyStore } from '../../store/usePolicyStore.js'
import useAuthStore from '../../store/authStore.js'
import { useMessengerStore } from '../../store/messengerStore.js'
import { cls } from '../../utils/helpers.js'
import { isNavKeyAvailable } from '../../config/featureModules.js'
import { MOBILE_NAV } from './navConstants.jsx'

export default function MobileBottomNav({ overdueCount }: { overdueCount?: number }) {
  const { t } = useLanguage()
  const { enabledModules, disabledItems, planFeatures, gbEnabled, platformModules, platformDisabledModules } = useSettingsStore()
  const policyModules = usePolicyStore(s => s.modules)
  const adminRole = useAuthStore(s => s.isAdmin())
  const totalUnread = useMessengerStore(s => s.totalUnread)

  const visibleTabs = MOBILE_NAV.filter(item =>
    isNavKeyAvailable(item.key, { adminRole, enabledModules, disabledItems, planFeatures, settingsFlags: { gbEnabled }, platformModules, platformDisabledModules, policyModules })
  )

  return (
    <nav className="mobile-bottom-nav">
      {visibleTabs.map(item => (
        <NavLink key={item.to} to={item.to} end={item.to === '/'}
          className={({ isActive }) => cls('mobile-nav-item', isActive && 'mobile-nav-active')}>
          <span className="mobile-nav-icon" style={{ position: 'relative' }}>
            {item.icon}
            {item.key === 'tasks' && (overdueCount ?? 0) > 0 && (
              <span style={{ position: 'absolute', top: -4, right: -4, background: 'var(--danger)', color: 'var(--text-primary)', fontSize: 'var(--text-micro)', fontWeight: 700, borderRadius: '100px', padding: '1px 4px', lineHeight: 1.4 }}>
                {overdueCount}
              </span>
            )}
            {item.key === 'navComms' && totalUnread > 0 && (
              <span
                aria-label={t('comms.unreadBadge', { count: totalUnread })}
                style={{ position: 'absolute', top: -4, right: -4, background: 'var(--danger)', color: 'var(--text-primary)', fontSize: 'var(--text-micro)', fontWeight: 700, borderRadius: '100px', padding: '1px 4px', lineHeight: 1.4 }}
              >
                {totalUnread > 99 ? '99+' : totalUnread}
              </span>
            )}
          </span>
          <span className="mobile-nav-label">{t(item.key) || item.key}</span>
        </NavLink>
      ))}
    </nav>
  )
}
